<template>
  <v-app :class="[
    { 'logged': loggedIn && !noMainMenuFromV4 && routeName !== 'ExpiredLink' && routeName !== 'CheckLink' },
    `route--${routeName && routeName.toLowerCase()}`,
    { 'no-main-menu-from-v4': noMainMenuFromV4 }
  ]">
    <CorpHeader v-if="loggedIn && !noMainMenu" />

    <!-- 预发环境提示 -->
    <div v-if="isStaging" class="staging-notice">
      <span>The current data is online data. Please be cautious when operating!!!</span>

    </div>

    <!-- old -->
    <CorpSnackbar />

    <!-- new -->
    <Snackbar />

    <Watermark v-if="loggedIn" />

    <ExpiresSessionDialog
      :visible="loggedIn && expiresSessionDialog"
      @close="closeExpiresSessionDialog"
    />

    <BrowserCompatibilityDialog
      :visible="browserCompatibilityDialog.visibility"
      :browser="browserCompatibilityDialog.browser"
      :version="browserCompatibilityDialog.version"
      @close="closeBrowserCompatibilityDialog"
    />

    <ConnectionMonitoring />

    <v-content>
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { detect } from 'detect-browser'
import { hasRole } from 'utils/functions'
import { SESSION_EXPIRES_WARNING_VALUE, SESSION_EXPIRES_WARNING_UNIT, SESSION_FAVORITE_ADDRESS, SESSION_HEADERS, SESSION_GRAY_USER_V4 } from 'utils/constants'
import moment from 'moment'
import store from '@/store'
import CorpHeader from 'components/CorpHeader'
import CorpSnackbar from 'components/CorpSnackbar'
import Snackbar from 'components/Snackbar'
import Watermark from 'components/Watermark'
import ExpiresSessionDialog from 'components/ExpiresSessionDialog'
import BrowserCompatibilityDialog from 'components/browserCompatibilityDialog'
import ConnectionMonitoring from 'components/ConnectionMonitoring'
import { Omega } from 'common/omega'
import { jsonParse } from 'utils/jsonUtil'

export default {
  name: 'App',
  components: {
    CorpHeader,
    CorpSnackbar,
    Snackbar,
    Watermark,
    ExpiresSessionDialog,
    BrowserCompatibilityDialog,
    ConnectionMonitoring
  },
  computed: {
    ...mapState({
      loggedIn: state => state.session.status.loggedIn,
      user: state => state?.session?.user?.business,
      sessionExpiresTime: state => state.sessionExpiresTime.date,
      noMainMenuFromV4: state => state.mainMenu.noMainMenuFromV4
    }),

    routeName () {
      return this.$route.name
    },

    noMainMenu () {
      return this.noMainMenuFromV4 || this.$route.meta.noMainMenu
    },

    browserInfo: () => detect(),

    isStaging () {
      return !this.noMainMenuFromV4 && process.env.NODE_ENV === 'staging'
    }
  },

  data () {
    return {
      welcomeDialog: false,
      sessionListener: null,
      expiresSessionDialog: false,
      browserCompatibilityDialog: {
        visibility: false,
        browser: null,
        ver: null
      },
      addressIndex: 0
    }
  },
  methods: {
    ...mapActions({
      getV3Config: 'commonConfig/getV3Config',
      setNoMainMenuFromV4: 'mainMenu/setNoMainMenuFromV4'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    redirectToMockEnv () {
      window.location.href = 'https://dsim435-api.intra.xiaojukeji.com/d-server-ngw/multi_env_mock/b2b-corporate-front/'
    },

    checkBrowserCompatibility () {
      const { name, version, os } = this.browserInfo
      const browser = name.toLowerCase()
      const ver = version ? Number(version.split('.')[0]) : null

      if (browser === 'chrome' && ver <= 72) {
        return this.openBrowserCompatibilityDialog({ browser, ver })
      }

      if (browser === 'firefox' && ver <= 64) {
        return this.openBrowserCompatibilityDialog({ browser, ver })
      }

      if (browser === 'safari' && ver <= 9) {
        // return this.openBrowserCompatibilityDialog({ browser, ver })
      }

      if (browser === 'ie' && ver <= 10) {
        return this.openBrowserCompatibilityDialog({ browser: 'internet explorer', ver })
      }

      if (os === 'opera-mini' || os === 'opera') {
        return this.openBrowserCompatibilityDialog({ browser: 'not supported', ver: 0 })
      }
    },

    closeBrowserCompatibilityDialog () {
      this.browserCompatibilityDialog = {
        visibility: false,
        browser: null,
        version: null
      }
    },

    openBrowserCompatibilityDialog ({ browser, ver }) {
      this.browserCompatibilityDialog = {
        visibility: true,
        browser,
        version: ver
      }
    },

    normalizeUserName (string) {
      const nameList = string.split(/\s+/)

      return nameList.map(name => {
        const letters = name.split('')
        return letters.map((letter, index) => index === 0 ? letter.toUpperCase() : letter).join('')
      }).join(' ')
    },

    chatVisibility () {
      setTimeout(() => {
        if (!window.zE) {
          return this.chatVisibility()
        }

        if (this.loggedIn) {
          const { name, email } = this.user || {}

          // https://developer.zendesk.com/api-reference/widget/api/#ze.identify
          window.zE('webWidget', 'setLocale', 'pt-BR')
          window.zE('webWidget', 'show')
          window.zE(() => window.zE.identify({ name: this.normalizeUserName(name), email }))
          return
        }

        window.zE('webWidget', 'hide')
      }, 2000)
    },

    checkHostname () {
      const hostname = location.hostname
      const port = location.port

      if (process.env.NODE_ENV === 'development' && hostname !== 'developer') {
        location.href = `http://developer:${port}`
      }
    },

    preventDefaultCopyPaste (e) {
      e.preventDefault()
    },

    addPreventCopyAndPasteText () {
      if (this.loggedIn && this.hasRole('ui', 'UI_DISABLE_COPY')) {
        document.addEventListener('copy', this.preventDefaultCopyPaste)
        document.addEventListener('paste', this.preventDefaultCopyPaste)
      }
    },

    removePreventCopyAndPasteText () {
      document.removeEventListener('copy', this.preventDefaultCopyPaste)
      document.removeEventListener('paste', this.preventDefaultCopyPaste)
    },

    openExpiresSessionDialog () {
      this.expiresSessionDialog = true
    },

    closeExpiresSessionDialog () {
      this.expiresSessionDialog = false
    },

    checkActiveSession () {
      const expiresDateMilliseconds = moment(this.sessionExpiresTime)
        .subtract(SESSION_EXPIRES_WARNING_VALUE, SESSION_EXPIRES_WARNING_UNIT)
        .format('x')
      const timeInterval = 10000 // 1m (60 * 1000 = 60000)

      this.sessionListener = setInterval(() => {
        const nowMilliseconds = Number(moment().format('x'))

        if (nowMilliseconds >= expiresDateMilliseconds) {
          this.openExpiresSessionDialog()
          clearInterval(this.sessionListener)
        }
      }, timeInterval)
    },

    async gmapsInit () {
      if (this.loggedIn) {
        await this.$gmaps.init()
      }
    },

    async addWebCallAddressOnLocalStorage () {
      try {
        const address = JSON.parse(localStorage.getItem(SESSION_FAVORITE_ADDRESS))

        if (address) {
          setTimeout(async () => {
            const currentAddress = address[this.addressIndex]

            if (this.addressIndex === 0) {
              console.log('%cIniciando captura dos endereços no localStorage', 'font-weight: bold')
            }

            if (currentAddress) {
              const addressObject = {
                address: currentAddress.address,
                latitude: currentAddress.latitude,
                longitude: currentAddress.longitude
              }

              await this.$apiService.createFavoriteAddress(this.user?.legacyUserId, addressObject)
              this.addWebCallAddressOnLocalStorage()
              this.addressIndex++
            } else {
              localStorage.removeItem(SESSION_FAVORITE_ADDRESS)
              console.log('%cFinalizada a captura dos endereços no localStorage', 'font-weight: bold')
              this.$ga.event('webcall favorite locale', 'save', 'addresses migrated successfully')
            }
          }, 1000)
        } else {
          console.log('%cEndereços já foram migrados', 'font-weight: bold')
        }
      } catch (error) {
        console.log('ERROR', error)
      }
    }
  },
  watch: {
    loggedIn (val) {
      this.addPreventCopyAndPasteText()
      this.chatVisibility()
      !val && this.removePreventCopyAndPasteText()
      this.gmapsInit()

      // if (val) {
      //   this.checkActiveSession()
      // } else {
      //   clearInterval(this.sessionListener)
      // }

      val && this.addWebCallAddressOnLocalStorage()
    }
  },
  async created () {
    // 全量之后，全部跳转至v4
    const jumptoV4 = true
    // 不在iframe中，且命中灰度，跳转至v4
    if (jumptoV4 && process.env.VUE_APP_V4_BASE && !this.noMainMenuFromV4) {
      // 检查是否为JP域名, 如果是JP域名, 则跳转至JP V4，只在预发和线上环境生效
      const host = window.location.hostname
      const isSim = host.includes('api.intra.xiaojukeji.com')
      if (isSim) {
        window.location.href = process.env.VUE_APP_V4_BASE
      } else {
        window.location.href = window.location.origin + '/v4/'
      }
    }
    await this.gmapsInit()
    /** 有登录状态，才会去请求品类配置 */
    const session = JSON.parse(localStorage.getItem(SESSION_HEADERS))
    if (session && session.authorization) {
      await this.getV3Config()
    }
  },
  mounted () {
    Omega.init(this.user?.name)
    console.log(process.env.VUE_APP_TITLE, process.env.VUE_APP_VERSION)
    console.log('VUE_APP_COMMIT_VERSION: ', process.env.VUE_APP_COMMIT_VERSION)
    this.addPreventCopyAndPasteText()
    this.chatVisibility()
    this.checkBrowserCompatibility()
    // this.loggedIn && this.checkActiveSession()
    this.loggedIn && this.addWebCallAddressOnLocalStorage()
    const $router = this.$router
    window.addEventListener('message', (ev) => {
      console.log('message', ev)

      if (ev.data && ev.data.msgType === 'loginTimeout') {
        console.log('interceptors logout', 'engreta')
        store.dispatch('session/logout')
        store.dispatch('company/clearSelectedCompany')
      } else if (ev.data && ev.data.msgType === 'gotoRouter') {
        ev.data.routerName && $router.push({ name: ev.data.routerName })
      }
      const data = jsonParse(ev.data)

      if (data && data.msgType === 'navigateToPath') {
        // 处理基于路径的导航请求
        if (data.path) {
          // 导航到指定路径
          $router.push(data.path)

          // 如果有navigationId，返回导航结果
          if (data.navigationId && window.parent && window.parent !== window) {
            const responseData = JSON.stringify({
              navigationId: data.navigationId,
              msgType: 'navigationResult',
              success: true,
              message: '导航成功',
              path: data.path
            })
            window.parent.postMessage(responseData, '*')
          }
        }
      }
      if (data) {
        const { routerName, msgType } = data || {}
        if (msgType === 'fromV4') {
          if (routerName) {
            $router.push({ name: routerName })
          }
        }
      }
      // console.info(ev)
    }, false)
  },
  beforeDestroy () {
    this.removePreventCopyAndPasteText()
  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/app';

.logged {
  padding-left: 0;

  @media (min-width: 768px) and (max-width: 1199px) {
    padding-left: 72px;
  }

  @media (min-width: 1200px) {
    padding-left: 0;
  }
}

#launcher {
  z-index: 5 !important
}

.staging-notice {
  position: fixed;
  top: 0;
  right: 50%;
  z-index: 1000;
  background-color: rgba(255, 87, 34, 0.9);
  color: white;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  font-size: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  span {
    margin-right: 10px;
  }

  .v-btn {
    margin-left: 8px;
    height: 24px;
    font-size: 12px;
  }
}
</style>
